import { BaseModel } from 'paliari-js-utils'
import Comentario from './Comentario'
import DocIrregularidade from './DocIrregularidade'
import DocItem from './DocItem'
import DocLocal from './DocLocal'
import DocTexto from './DocTexto'
import DocValor from './DocValor'
import Usuario from './Usuario'

const attributes = {
  id: null,
  numero: null,
  ano: null,
  tipo_entrega: '',
  valor_total: 0,
  prazo_regularizar: 0,
  modelo: null,
  modelo_id: null,
  cadastro: null,
  cadastro_id: null,
  doc: null,
  doc_id: null,
  tipo: '',
  url: '',
  grau_de_infracao: '',
  fiscal_id: null,
  fiscal: (obj = {}) => new Usuario(obj),
  irregularidades: (p = []) => p.map(i => new DocIrregularidade(i)),
  todas_irregularidades: (p = []) => p.map(i => new DocIrregularidade(i)),
  comentarios: (p = []) => p.map(i => new Comentario(i)),
  items: (p = []) => p.map(i => new DocItem(i)),
  textos: (p = []) => p.map(i => new DocTexto(i)),
  valores: (p = []) => p.map(i => new DocValor(i)),
  local: (obj = {}) => new DocLocal(obj),
  _rascunho: false,
  permite_editar: false,
}

class Doc extends BaseModel {
  constructor(obj) {
    super(attributes, obj)
    if (obj.permite_editar) this._rascunho = true
    if (!this.local) this.local = new DocLocal({})
  }

  get irregularidade_codigos_destroy() {
    if (!this.todas_irregularidades) return []
    return this.todas_irregularidades
      .filter(item => item.id && !item._selected)
      .map(item => item.codigo)
  }

  get irregularidade_codigos_add() {
    if (!this.todas_irregularidades) return []
    return this.todas_irregularidades
      .filter(item => item._selected)
      .map(item => item.codigo)
  }

  get postParams() {
    const {
      modelo,
      cadastro,
      fiscal,
      doc,
      url,
      irregularidades,
      todas_irregularidades,
      permite_editar,
      irregularidade_codigos_add,
      irregularidade_codigos_destroy,
      ...data
    } = this

    return {
      ...data,
      irregularidade_codigos_destroy,
      irregularidade_codigos_add,
    }
  }
}

export default Doc
